/**
 * Shared helpers for rendering Plasmodium species abbreviations in italics.
 */

export const ITALIC_SPECIES_LABELS: ReadonlySet<string> = new Set([
  "Pf",
  "Pv",
  "Pk",
  "Po",
  "Pm",
])

interface SpeciesLabelProps {
  label: string
}

export function SpeciesLabel({ label }: SpeciesLabelProps): React.JSX.Element {
  const firstSpaceIndex: number = label.indexOf(" ")
  const firstToken: string =
    firstSpaceIndex === -1 ? label : label.slice(0, firstSpaceIndex)

  if (!ITALIC_SPECIES_LABELS.has(firstToken)) {
    return <>{label}</>
  }

  const remainder: string = firstSpaceIndex === -1 ? "" : label.slice(firstSpaceIndex)
  return (
    <>
      <span className="italic">{firstToken}</span>
      {remainder}
    </>
  )
}
